<!--
@Create By Tim For 19/08/23
@培训需求组件
-->
<template>
  <div class="Demand">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>培训需求</el-breadcrumb-item>
        <el-breadcrumb-item></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="DemandForm">
      <el-form :model="DemandForm" :rules="rules" ref="DemandForm" label-suffix="：" label-width="100px">
        <el-form-item label="姓名"><el-input disabled v-model.trim="DemandForm.userName"></el-input></el-form-item>

        <el-form-item label="部门"><el-input disabled v-model.trim="DemandForm.department"></el-input></el-form-item>

        <el-form-item label="角色" prop="userRole"><el-input placeholder="请输入您的角色" clearable v-model.trim="DemandForm.userRole"></el-input></el-form-item>

        <el-form-item label="期望时间" prop="expectedTime">
          <el-date-picker
            clearable
            v-model="DemandForm.expectedTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="dates"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="期望讲师" prop="expectedLecturer">
          <el-input clearable placeholder="请输入您期望的讲师" v-model.trim="DemandForm.expectedLecturer"></el-input>
        </el-form-item>

        <el-form-item label="诉求" prop="appeal">
          <el-input type="textarea" clearable :row="4" placeholder="请输入诉求" v-model.trim="DemandForm.appeal" maxlength="300" show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <!-- 提交按钮 -->
      <div class="submitBtn">
        <el-button @click="reset">重置</el-button>
        <el-button @click="submitDemand" type="primary">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../config/api';

export default {
  name: 'Demand',
  data() {
    return {
      // 禁止选择当前往前的日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '三天后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          },
          {
            text: '两周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      // 培训需求表单对象
      DemandForm: {
        // 姓名
        userName: '',
        // 部门
        department: '',
        // 角色
        userRole: '',
        // 期望时间
        expectedTime: '',
        // 期望讲师
        expectedLecturer: '',
        // 诉求
        appeal: ''
      },
      // 培训需求表单对象校验规则
      rules: {
        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        department: [{ required: true, message: '请输入部门', trigger: 'blur' }],
        userRole: [{ required: true, message: '请输入角色', trigger: 'blur' }],
        expectedTime: [{ required: true, message: '请输入期望时间', trigger: 'blur' }],
        expectedLecturer: [{ required: true, message: '请输入期望讲师', trigger: 'blur' }],
        appeal: [{ required: true, message: '请输入诉求', trigger: 'blur' }, { min: 1, max: 300, message: '最多输入300字符', trigger: 'blur' }]
      }
    };
  },
  created() {},

  mounted() {
    this.getUserInfo();
  },

  methods: {
    // 清空表单
    reset() {
      this.$refs['DemandForm'].resetFields();
    },

    // 提交需求
    submitDemand() {
      this.$refs['DemandForm'].validate(valid => {
        if (valid) {
          let data = {
            userId: this.DemandForm.userId,
            userName: this.DemandForm.userName,
            department: this.DemandForm.department,
            userRole: this.DemandForm.userRole,
            expectedTime: this.DemandForm.expectedTime,
            expectedLecturer: this.DemandForm.expectedLecturer,
            appeal: this.DemandForm.appeal
          };
          this.$axios.post(api + 'portal/appeal', data).then(res => {
            this.$message.success('需求发布成功！');
            this.$refs['DemandForm'].resetFields();
          });
        }
      });
    },

    // 查询姓名+部门
    getUserInfo() {
      this.$axios.get(process.env.VUE_APP_SSO_HOST_URL + 'system/user/profile/crurrent', { headers: { response_type: 'token' } }).then(res => {
        this.DemandForm.userId = res.userId;
        this.DemandForm.userName = res.userName;
        this.DemandForm.department = res.dept.deptName;
      });
    }
  }
};
</script>

<style scoped>
.Demand .title {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #000;
  border-bottom: 1px solid #d3d3d3;
}

.Demand .DemandForm {
  padding-top: 30px;
  width: 700px;
  min-height: 500px;
  margin: 0 auto;
}

.Demand .submitBtn {
  height: 40px;
  text-align: center;
}

.Demand .dates {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/Demand/Demand.vue